import Vue from 'vue'

const getUUID = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 3 | 8);
    return v.toString(16);
  });
}

const decodeObj = function(obj){
  let result = {};
  let temp = obj;
  if(typeof obj === 'function'){
    temp = obj();
  }
  if(typeof temp === 'string'){
    result = {};
    result.code = temp;
    result.field = [];
  }else if(typeof temp === 'object'){
    result = temp;
  }
  if(typeof result.field === 'undefined'){
    result.field = [];
  }
  return result;
}

const state = {
  message: {},
  showWait: false,
};

const mutations = {
  ADD_MSG(state, value){
    const key = value.key;
    if(key === null || key === undefined) return;
    Vue.set(state.message, key, value);
  },
  REMOVE_MSG(state, key){
    Vue.delete(state.message, key);
  },
  SHOW_WAIT(state){
    state.showWait = true;
  },
  HIDE_WAIT(state){
    state.showWait = false;
  }
};

const actions = {
  popAlert({ dispatch }, obj){
    const option = decodeObj(obj);
    option.type = 'alert';
    return dispatch('popMsg', option);
  },
  popConfirm({ dispatch }, obj){
    const option = decodeObj(obj);
    option.type = 'confirm';
    return dispatch('popMsg', option);
  },
  popMsg({ commit }, obj){
    const key = getUUID();
    return new Promise((resolve, reject) => {
      const info = {
        key,
        code: obj.code,
        field: obj.field,
        text: obj.text,
        resolve,
        reject,
        type: obj.type||'message'
      }
      commit('ADD_MSG', info);
    })
  },
  closePopMsg({ commit, state }, obj){
    const key = obj.key;
    const info = state.message[key];
    if(info !== undefined && info !== null){
      const resolve = info.resolve;
      commit('REMOVE_MSG', key);
      if(resolve){
        resolve(obj.value);
      }
    }
  },
  popWait({ commit }){
    commit('SHOW_WAIT')
  },
  stopWait({ commit }){
    commit('HIDE_WAIT')
  },
};

const getters = {
    messageInfo: (state) => (key) => state.message[key],
    messageList: (state) => state.message,
    showWait: (state) => state.showWait,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
